import { environment } from '../../environments/environment'
export function liveBetting(sbToken, key, url, merchantType) {
    if (environment) {
        var script = document.createElement('script');
        script.src = `${url}`;
        script.onload = function () {
            var token = sbToken;
            var lang = "en-GB";

            if (key == 'Y') {
                const integrationValue = merchantType == 'GY' ? environment.altenarIntegrationGY : environment.altenarIntegrationJM;
                window.altenarWSDK.init({ integration: integrationValue, culture: 'en-GB', token: token });

                var ASB = window.altenarWSDK.addSportsBook({
                    props: {
                        page: 'live',
                        routerType: 'memory',
                        onRouteChange: onRouteCallback,
                        onBetPlacement: betPlaceCallback
                    },
                    container: document.getElementById('sb2Container'),
                })

                function onRouteCallback(altenarProps) {
                    window.scroll(0, 0);
                };

                function betPlaceCallback(bets) {
                    var event = new CustomEvent('live-callback', { detail: bets });
                    window.dispatchEvent(event);
                }

                window.addEventListener("Destroy-Live", (e) => {
                    ASB.remove();
                });
            } else {
                var initParams = { walletcode: merchantType == 'GY' ? environment.walletCodeGY : environment.walletCodeJM, token: token, lang: lang, page: 'live', Currency: 'JMD', isHashMode: false }

                var ASb = new AltenarSportsbook('#sb2Container', initParams, { triggerCallback: true });
                ASb.getParams();
                ASb.setParam('placebetcallback', function (e) {
                    if (e.length > 0) {
                        let betIDarray = [];
                        for (let i = 0; i < e.length; i++) {
                            betIDarray.push(e[i].betId)
                        }
                        var event = new CustomEvent('callBack', { detail: betIDarray });
                        window.dispatchEvent(event);
                    }
                });
                window.addEventListener("Destroy-Live", function (e) {
                    ASb.destroy();
                });
            }
        }

        document.documentElement.appendChild(script);
    }
}


